import store from '@/store/store'

class ConversationDetailModule {

  setMessages(messages) {
    store.commit('MESSAGE_LIST_SET', messages)
  }

  getMessages = () => store.state.conversationDetail.messageList

  setRequests(requests) {
    store.commit('REQUEST_LIST_SET', requests)
  }

  getRequests = () => store.state.conversationDetail.requestList

  setIntentSuggestions(intentSuggestions) {
    store.commit('INTENT_SUGGESTIONS_SET', intentSuggestions)
  }

  setIntentSuggestion(messageId, intentSuggestion) {
    store.commit('INTENT_SUGGESTION_SET', { messageId, intentSuggestion })
  }

  getIntentSuggestions = () => store.state.conversationDetail.intentSuggestions
}

export default new ConversationDetailModule()
